import React, {Suspense} from 'react'
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {I18nProvider} from '../_khaugali/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_khaugali/layout/core'
import {MasterInit} from '../_khaugali/layout/MasterInit'
import {MasterLayout} from '../_khaugali/layout/MasterLayout'
import {Logout} from './modules/auth'
import AuthInit from './modules/auth/redux/AuthInit'
import {ErrorsPage} from './modules/errors/ErrorsPage'
import {PrivateRoutes} from './routing/PrivateRoutes'
import {Routes} from './routing/Routes'

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Routes />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
